import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes.js';
import PublicRoutes from './PublicRoutes.js';
import signIn from '../components/signIn';
import signUp from '../components/signUp';
import AdminPanel from '../components/adminPanel';
import ForgotPassword from '../components/forgotPassword';
import EmailVerify from '../components/emailVerify';
import NewUserRegister from '../components/newUserRegister';
import ChangePassword from '../components/changePassword';
import MySettings from '../components/mySettings';
import costCalculator from '../components/costCalculator'
import CandidateSearch from '../components/adminPanel/candidateSearch/index.js';
import { createBrowserHistory } from 'history';
import NotFound from '../components/notFound';
export const history = createBrowserHistory();


const Routes = () => {

    return (
        <div>
            <BrowserRouter basename={'app'}>
                <Switch>
                    {/* Company Public Routes */}
                    <PublicRoutes component={signIn} path={`/signin`} exact />
                    <PublicRoutes component={signUp} path={`/signup`} exact />
                    <PublicRoutes component={ForgotPassword} path={`/forgotpassword`} exact />
                    <PublicRoutes component={NewUserRegister} path={`/join-company-user/:id`} exact />
                    <PublicRoutes component={costCalculator} path={`/cost-calculator`} exact />

                    {/* Company Internal Routes */}
                    <PrivateRoutes component={AdminPanel} path={`/company`} />
                    <PrivateRoutes component={EmailVerify} path={`/email-verify`} exact />
                    <PrivateRoutes component={ChangePassword} path={`/changePassword`} exact />
                    <PrivateRoutes component={MySettings} path={`/my-settings`} />
                    <PrivateRoutes component={CandidateSearch} path={`/candidate-search`} />

                    {/* 404 error page */}
                    <Route path="*" component={NotFound} />


                </Switch>
            </BrowserRouter>
        </div>
    )
}
export default Routes;